<div class="rm-card">
  <h2 class="rm-heading">REVIEW MANAGEMENT</h2>

  <!-- Review Distribution -->
  <div class="rm-section">
    <div class="rm-section-header">
      <span class="rm-section-title">Review Distribution as type of Work</span>
      <button class="add-review-btn" routerLink="/planning">+ Add New Review</button>
    </div>
    <div class="review-dist-row">
      <button type="button" class="stat-card clickable-tile" [class.tooltip-host]="type.tooltipLines?.length"
        *ngFor="let type of reviewTypes" (click)="selectReviewType(type.reviewTypeId)">
        <span class="stat-num purple">{{ type.count }}</span>
        <span class="stat-lbl">{{ type.label }}</span>
        <div class="tooltip-box" *ngIf="type.tooltipLines?.length">
          <strong class="tooltip-title">{{ type.label }}</strong>
          <span class="tooltip-line" *ngFor="let line of type.tooltipLines">{{ line }}</span>
        </div>
      </button>
      <button type="button" class="stat-card stat-card--highlight tooltip-host clickable-tile"
        (click)="selectTotalReviews()">
        <span class="stat-num white">{{ totalReviews }}</span>
        <span class="stat-lbl white">Total Reviews</span>
        <span class="stat-lbl white">Incl. all statuses</span>
        <div class="tooltip-box">
          <strong class="tooltip-title">Total Reviews</strong>
          <span class="tooltip-line" *ngFor="let line of totalReviewsTooltipLines">{{ line }}</span>
        </div>
      </button>
    </div>
  </div>

  <!-- Review Status -->
  <div class="rm-section">
    <div class="rm-section-header">
      <span class="rm-section-title">Number of Review as per Status</span>
    </div>
    <div class="status-cards-row">
      <button type="button" class="stat-card tooltip-host clickable-tile" *ngFor="let status of reviewStatuses"
        (click)="selectReviewStatus(status.label)">
        <span class="stat-num purple">{{ status.count }}</span>
        <span class="stat-lbl">{{ status.label }}</span>
        <div class="tooltip-box">
          <strong class="tooltip-title">{{ status.label }} ({{ status.count }}) — Sub Statuses</strong>
          <span class="tooltip-line" *ngFor="let sub of status.subStatuses">{{ sub.label }}: {{ sub.count }}</span>
          <span class="tooltip-line" *ngIf="!status.subStatuses?.length">No sub-status data</span>
          <hr class="tooltip-divider" *ngIf="status.label === 'Report Published'" />
          <span class="tooltip-line tooltip-ratings" *ngIf="status.label === 'Report Published'">
            <strong>Ratings: </strong> <ng-container *ngFor="let r of reportRatings; let last = last">{{ r.label }}: {{ r.count }}<ng-container *ngIf="!last"> &middot; </ng-container></ng-container>
          </span>
        </div>
      </button>
    </div>
  </div>

  <!-- Report Ratings -->
  <div class="rm-section">
    <div class="rm-section-header">
      <span class="rm-section-title">Overall Report Review Rating</span>
    </div>
    <div class="rating-tiles">
      <button
        type="button"
        class="rating-tile clickable-tile"
        [class.rating-tile--dark]="rating.darkText"
        [style.background-color]="rating.color"
        *ngFor="let rating of reportRatings"
        (click)="selectReviewRating(rating.label)"
      >
        <span class="rating-num">{{ rating.count }}</span>
        <span class="rating-lbl">{{ rating.label }}</span>
      </button>
    </div>
  </div>
</div>
